// Custom logger to be initialised per module for vuex actions & mutations.
export default class Logger {
  constructor(store, type) {
    this.store = store;
    this.type = type;
  }

  info(action, message, data) {
    // Log only in development
    if (process.env.NODE_ENV !== 'development') {
      return;
    }

    console.groupCollapsed(`%c[${this.store}: ${this.type}]`, 'color: #5CAAC3;', '-', action);
    console.log(message, data);
    console.groupEnd();
  }

  warn(action, message, data) {
    // Log only in development
    if (process.env.NODE_ENV !== 'development') {
      return;
    }

    console.groupCollapsed(`%c[${this.store}: ${this.type}]`, 'color: #E76B66;', '-', action);
    console.log(message, data);
    console.groupEnd();
  }
}
